let cmdBuf = [];
let cmdIng = false;

const CmdBuf = {
  bind: f => {
    return function() {
      cmdBuf = [...cmdBuf, { cmd: f, param: arguments[0] }];
    };
  },
  bindD: f => {
    return function(count) {
      if (count) {
        const max = Math.abs(count);
        const param = count / max;
        for (let i = 0; i < max; i++)
          cmdBuf = [...cmdBuf, { cmd: f, param: param }];
      } else {
        cmdBuf = [...cmdBuf, { cmd: f, param: 1 }];
      }
    };
  },
  bindCancel: f => {
    if (cmdIng) cmdBuf = [{ cmd: f, param: null }];
    else cmdBuf = [];
  },
  play: () => {
    cmdIng = false;
    if (cmdBuf.length > 0) {
      cmdIng = true;
      const { cmd, param } = cmdBuf.shift();
      cmd.call(null, param);
      if (cmdBuf.length === 0) cmdIng = false;
    }
  },
  isIng: () => {
    return cmdIng;
  },
  end: () => {
    cmdBuf = [];
    cmdIng = false;
  }
};

export default CmdBuf;
